module.exports = __webpack_public_path__ + "img/search.eca8674d.svg";